import React from 'react';

import {
  DESKTOP_SEARCH_BAR_EPPO_ID,
  DESKTOP_SEARCH_BAR_EPPO_ID_VALUES,
} from '~/components/Eppo/constants';
import { useEppoStringAssignment } from '~/components/Eppo/helpers';

import { Hero } from '../Hero/Hero';
import { HeroExpanded } from '../HeroExpanded/HeroExpanded';

import type { ReactElement } from 'react';
import type { SearchFilters } from '~/common/types/search';

type Props = {
  handleFiltersSave: (searchFilters: SearchFilters) => void;
  searchFilters: SearchFilters;
};

export const HeroWrapper = (props: Props): ReactElement => {
  const isNewDesktopSearchBarEnabled =
    useEppoStringAssignment(DESKTOP_SEARCH_BAR_EPPO_ID) === DESKTOP_SEARCH_BAR_EPPO_ID_VALUES.ON;

  if (isNewDesktopSearchBarEnabled) {
    return <HeroExpanded {...props} />;
  }

  return <Hero {...props} />;
};
